import { lazy } from 'react';

export const StylePromptFormPageLazy = lazy(() => import('./StylePromptFormPage'));
